<template>
  <div
    :id="modalId"
    :class="classes"
    :style="this.styles"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog">
      <div v-if="data" class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('generic-str.lbl-edit-contact')}}</h5>
          <button type="button" class="close" @click="hide" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="save" class="form-horizontal">
          <div class="modal-body">
            <div class="form-body">
              <div class="form-group row">
                <label class="control-label text-right text-left-m col-md-4"
                  >{{$t('generic-str.lbl-first-name')}}</label
                >
                <div class="col-md-6">
                  <input
                    v-model="form.first_name"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-right text-left-m col-md-4"
                  >{{$t('generic-str.lbl-last-name')}}</label
                >
                <div class="col-md-6">
                  <input
                    v-model="form.last_name"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-right text-left-m col-md-4"
                  >{{$t('generic-str.lbl-cellphone')}}</label
                >
                <div class="col-md-6">
                  <!--<vue-tel-input
                    ref="phone"
                    v-model="form.mobile_number"
                    @country-changed="changeCountry"
                    v-bind="bindProps"
                  ></vue-tel-input>
                  <div class="invalid-feedback" :class="{ show: invalidPhone }">
                    Telefone inválido
                  </div>-->
                  <tel-input
                    ref="mobile_number"
                    v-if="isShow"
                    v-model="form.mobile_number"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="control-label text-right text-left-m col-md-4"
                  >Email</label
                >
                <div class="col-md-6">
                  <input
                    v-model="form.email"
                    type="email"
                    class="form-control"
                  />
                </div>
              </div>
              <div v-if="!group" class="form-group row">
                <label class="control-label text-right text-left-m col-md-4"
                  >{{$t('sms.send-msg.tabs.groups.title')}}</label
                >
                <div class="col-md-6">
                  <select-input
                    multiple
                    label="name"
                    :reduce="(group) => group.id"
                    v-model="form.groups"
                    :options="groups"
                    :clearable="false"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hide">
              {{$t('generic-str.cancel')}}
            </button>
            <button
              :disabled="isSending"
              type="submit"
              :class="{ 'qt-loader qt-loader-mini qt-loader-right': isSending }"
              class="btn btn-primary"
            >
              {{$t('generic-str.save')}}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ContactService from '@/services/contact.service';
import Modal from '@/mixins/Modal';
import SelectInput from '@/components/SelectInput.vue';
import TelInput from '@/components/form/TelInput.vue';
// import { VueTelInput } from 'vue-tel-input';

export default {
  components: {
    SelectInput,
    TelInput,
    // VueTelInput,
  },
  mixins: [Modal],
  props: ['id', 'group'],
  data() {
    return {
      groups: [],
      isSending: false,
      mobile_number: null,
      invalidPhone: false,
      countryCode: '',
      form: {},
      bindProps: {
        mode: 'national',
        defaultCountry: 'BR',
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: true,
        placeholder: this.$t('generic-str.lbl-cellphone'),
        required: true,
        enabledCountryCode: false,
        enabledFlags: true,
        validCharactersOnly: true,
        preferredCountries: ['AU', 'BR'],
        onlyCountries: [],
        ignoredCountries: [],
        autocomplete: 'off',
        name: 'telephone',
        maxLen: 25,
        wrapperClasses: '',
        inputClasses: 'form-control',
        dropdownOptions: {
          disabledDialCode: false,
        },
        inputOptions: {
          showDialCode: false,
        },
      },
    };
  },
  mounted() {
    this.fetchGroups();
  },
  methods: {
    fetchGroups() {
      ContactService.getGroups().then(
        (groups) => {
          this.groups = groups;
        },
        (error) => {
          this.content = error;
        },
      );
    },
    changeCountry(e) {
      const tempNumber = this.form.mobile_number
        .replace(/\D/g, '')
        .split('(')[1];
      this.form.mobile_number = `${e.dialCode}${tempNumber}`;
    },
    save() {
      if (this.form.email) {
        this.isSending = true;
        // const dataSend = this.data;

        ContactService.editContact(this.form).then(
          () => {
            this.hide();
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: this.$t('contact-component.update'),
              type: 'success',
            });
            this.$emit('sent');
            this.form = {};
            this.isSending = false;
          },
          (error) => {
            this.$toast.show({
              title: `${this.$t('sms.infos.filters.status.lbl-error')} ${error.code}`,
              content: error.message,
              type: 'danger',
            });
            this.isSending = false;
          },
        );
      } else {
        this.$toast.show({
          title: this.$t('sms.infos.filters.status.lbl-error'),
          content: this.$t('contact-component.fail-phone-email'),
          type: 'danger',
        });
      }
    },
  },
};
</script>
